(function() {
  angular.module('cfn').controller('cropOverviewController', [
    '$scope',
    '$rootScope',
    'controllerData',
    function($scope, $rootScope, controllerData) {
      'use strict';

      let controller = this;

      $scope.cropOverviewController = this;
      // [ '2012', '2013', '2014']
      $scope.model = {
        harvestYears: _.sortBy(controllerData, (val) => { return val; } ).reverse()
      };

      // Initially selected
      if ($scope.model.harvestYears.length > 0) {
        $scope.model.selectedYear =
          $scope.model.harvestYears[$scope.model.harvestYears.length - 1];
      }

      controller.open = function() {
        $rootScope.goto('analyse/cropoverview/' + $scope.model.selectedYear);
      };

      return this;
    }
  ]);
})();
